import {
	GoogleAddressComponentsFields,
	ValidationMessages,
} from "globalConstants";
import {
	checkAddressFieldsEmpty,
	checkIsLatOrLngManual,
	getObjectByPath,
	isEmptyObject,
} from "helpers";
import moment from "moment";

export const baseEmailTemplateRegex =
	/^[a-z\d]((\.(?!\.))|[-\w+]){0,49}@[a-z\d\-.]{1,251}\.[a-z\d-]{1,50}$/i;
// eslint-disable-next-line no-useless-escape
export const subDomainRegex = /^[a-z\d]+([a-z\d]*\-(?!$)[a-z\d]*)*$/i;

export const allowed = (regex, message) => value => {
	return regex.test(value) ? null : message;
};

export const required = (value, allValues, props, name) => {
	return value ? null : "Field is required";
};

export const requiredForWebsite = (value, allValues, props, name) => {
	if (value) return undefined;
	return "Field is required";
};

export const warn = values => {
	const warnings = {};

	if (
		values.monthlyVMCD &&
		values.avgTicketVMCD &&
		values.avgTicketVMCD > 0
	) {
		let checkedValue = values.monthlyVMCD / values.avgTicketVMCD;
		warnings.avgTicketVMCD = `It looks like you process about ${Math.ceil(
			checkedValue,
		)} V/MC/D Transactions per month`;
	}

	if (
		values.monthlyAMEX &&
		values.avgTicketAMEX &&
		values.avgTicketAMEX > 0
	) {
		let checkedValue = values.monthlyAMEX / values.avgTicketAMEX;
		warnings.avgTicketAMEX = `It looks like you process about ${Math.ceil(
			checkedValue,
		)} Amex Transactions per month`;
	}

	if (
		(values.miscFeeNumberOneType === "1" ||
			values.miscFeeNumberOneType === "2") &&
		values.miscFeeNumberOnePercentage
	) {
		warnings.miscFeeNumberOnePercentage =
			"Percentage cannot be used with monthly or annual";
	}

	if (
		(values.miscFeeNumberTwoType === "1" ||
			values.miscFeeNumberTwoType === "2") &&
		values.miscFeeNumberTwoPercentage
	) {
		warnings.miscFeeNumberTwoPercentage =
			"Percentage cannot be used with monthly or annual";
	}

	if (
		(values.miscFeeNumberThreeType === "1" ||
			values.miscFeeNumberThreeType === "2") &&
		values.miscFeeNumberThreePercentage
	) {
		warnings.miscFeeNumberThreePercentage =
			"Percentage cannot be used with monthly or annual";
	}

	if (values.tokenization) {
		warnings.tokenization = "Additional Fee Warning";
	}

	return warnings;
};

export const matchesAddressRegex = allowed(
	/^[0-9a-z\-'’.,\s]*$/i,
	`Only letters, digits and .,-' are allowed`,
);

export const matchesCityRegex = allowed(
	/^[a-z\-'’.\s]*$/i,
	`Only letters, dashes, dots, and apostrophes are allowed`,
);

export const maxLength = max => value => {
	return value && value.length > max
		? `Max length is  ${max} symbols`
		: undefined;
};

export const maxLengthPhone = max => value => {
	return value && value.length > max ? `Max length is 10 digits` : undefined;
};

export const minLength = min => value => {
	return value && value.length < min
		? `Min length is ${min} symbols`
		: undefined;
};

export const minLengthPhone = min => value => {
	return value && value.length < min ? `Min length is 10 digits` : undefined;
};

export const maxValueEx = (max, units) => value => {
	return value && value > max
		? `Must be not more than ${max} ${units ? units : ""}`
		: undefined;
};

export const minValueEx = (min, units) => value => {
	return value && value < min
		? `Cannot be less than ${min} ${units}`
		: undefined;
};

const maxValue = max => value => {
	return value && value > max
		? `Must be not more than ${max} percent`
		: undefined;
};

const maxValueForNumberData = max => value => {
	return value && value > max
		? `Must be not more than ${max} digits`
		: undefined;
};

export const maxValueForANData = max => value => {
	return value && value > max
		? `Must be not more than ${max} characters`
		: undefined;
};

export const minValueForNumberData = min => value => {
	return value && value < min ? `Must be at least ${min} digits` : undefined;
};

export const minValueForANData = min => value => {
	return value && value < min
		? `Must be at least ${min} characters`
		: undefined;
};

export const minValue = min => value => {
	return value && value < min ? `Must be at least ${min} percent` : undefined;
};

export const minLengthTaxId = value => {
	return value && value.length < 10 ? `Min length is 9 symbols` : undefined;
};

export const maxLengthTaxId = value => {
	return value && value.length > 10 ? `Max length is 9 symbols` : undefined;
};

export const minLengthSSN = value => {
	return value && value.length < 11 ? `Min length is 9 symbols` : undefined;
};
export const maxLengthSSN = value => {
	return value && value.length > 11 ? `Max length is 9 symbols` : undefined;
};

export const validateUrl = value => {
	const re =
		// eslint-disable-next-line no-useless-escape
		/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,50}(:[0-9]{1,50})?(\/.*)?$/;

	return !re.test(value) ? `Incorrect website address` : undefined;
};

export const onlyDate = (value, previousValue) => {
	if (!value) {
		return value;
	}

	const containsOtherChars = /^\d/.test(value);

	if (
		value.length === 10 &&
		value.split("/").length === 3 &&
		!containsOtherChars
	) {
		//value already formated
		return value;
	}

	if (previousValue && value.length < previousValue.length) {
		return value;
	}

	const onlyNums = value.replace(/[^\d]/g, "");

	if (!previousValue || value.length > previousValue.length) {
		// typing forward
		if (onlyNums.length === 2) {
			return onlyNums + "/";
		}
		if (onlyNums.length === 4) {
			return onlyNums.slice(0, 2) + "/" + onlyNums.slice(2) + "/";
		}
		if (onlyNums.length >= 8) {
			return (
				onlyNums.slice(0, 2) +
				"/" +
				onlyNums.slice(2, 4) +
				"/" +
				onlyNums.slice(4, 8)
			);
		}
	}
	if (onlyNums.length <= 2) {
		return onlyNums;
	}
	if (onlyNums.length <= 4) {
		return onlyNums.slice(0, 2) + "/" + onlyNums.slice(2);
	}

	return (
		onlyNums.slice(0, 2) +
		"/" +
		onlyNums.slice(2, 4) +
		"/" +
		onlyNums.slice(4, 8)
	);
};

export const trim = value => value && value.trim();

export const emailValid = value => {
	const emailRequired = "Field is required";
	const error = "Invalid email address";

	if (!value) return emailRequired;
	if (value.length > 255) return error;
	if (!baseEmailTemplateRegex.test(value)) return error;

	const subDomains = value.split("@")[1].split(".");
	if (subDomains.length < 2) return error;

	const anySubDomainIsInvalid = subDomains.some(
		x => !x || x.length > 50 || !subDomainRegex.test(x),
	);

	if (anySubDomainIsInvalid) return error;

	let regEmail =
		// eslint-disable-next-line no-useless-escape
		/^(([^<>()\[\]\\,;:\s@"]+(\.[^<>()\[\]\\,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;
	return regEmail.test(value) ? null : error;
};

export const onlyPercent = (value, previousValue) => {
	if (!value) {
		return value;
	}

	let valueMatch = !!value.match(/^\d{0,3}(\.\d{0,2})?$/g);

	if (!valueMatch) {
		return previousValue;
	}
	const onlyNums = value.replace(/[^\d|.]/g, "");
	return onlyNums;
};

export const currency = (value, previousValue) => {
	if (!value) {
		return value;
	}

	let valueMatch = !!value.match(/^\d{0,20}(\.\d{0,2})?$/g);

	if (!valueMatch) {
		return previousValue;
	}
	const onlyNums = value.replace(/[^\d|.]/g, "");
	return onlyNums;
};

export const onlyDigits = (value, previousValue) => {
	if (!value) {
		return value;
	}
	const onlyNums = value.replace(/[^\d]/g, "");
	return onlyNums;
};

export const floatValidation = value => {
	if (!value) {
		return;
	}

	let valueMatch = !!value
		.toString()
		.match(/^((-\d{1,20})|\d{0,20})(\.\d{1,2})?$/g);
	if (!valueMatch) {
		return "Valid number is expected";
	}
};

export const digitsWithMinus = (value, previousValue) => {
	if (!value) {
		return value;
	}

	let valueMatch = !!value.match(/^-?\d{0,20}(\.\d{0,2})?$/g);
	if (!valueMatch) {
		return previousValue || "";
	}

	return value;
};

export const onlyNumberDate = value => {
	if (!value) {
		return value;
	}
	const onlyNums = value.replace(/[^\d]/g, "");
	return onlyNums;
};

export const onlyLetters = (value, previousValue) => {
	if (!value) {
		return value;
	}
	const onlyLetter = value.replace(/([^a-zA-Z\s])/g, "");
	return onlyLetter;
};

export const matchesNameRegex = allowed(
	/^[a-z\-'’\s]*$/i,
	`Only letters, dash or apostrophe are allowed`,
);

export const trimMidSentence = value => {
	if (!value) {
		return value;
	}

	const oneSpace = value.replace(/\s{2,}/, " ");
	return oneSpace;
};

export const noSpace = value => {
	if (!value) {
		return value;
	}

	const noSpace = value.replace(/\s/g, "");
	return noSpace;
};

export const onlyAlphaNumeric = value => {
	if (!value) {
		return value;
	}
	const onlyNums = value.replace(/[^\da-zA-Z]/g, "");
	return onlyNums;
};

export const onlyAlphanumericAndSpecialCharacters = value => {
	if (!value) {
		return value;
	}
	const onlyAllowedSymbols = value.replace(
		/([^a-zA-Z0-9\s!&#,.'"()_-])/g,
		"",
	);
	return onlyAllowedSymbols;
};

export const noSpecialCharacters = value => {
	if (!value) {
		return value;
	}
	const onlyAllowedSymbols = value.replace(/([^a-zA-Z0-9\s()_-])/g, "");
	return onlyAllowedSymbols;
};

export const noSpecialCharactersForNumber = value => {
	if (!value) {
		return value;
	}
	const onlyAllowedSymbols = value.replace(/([^0-9\s()_-])/g, "");
	return onlyAllowedSymbols;
};

export const normalizeDbaName = value => {
	if (!value) {
		return value;
	}
	const onlyAllowedSymbols = value.replace(
		/([^a-zA-Z0-9\s!&#,.'()_/@$%*+:-])/g,
		"",
	);
	return onlyAllowedSymbols;
};

export const specialCharacters = value => {
	if (!value) {
		return value;
	}

	const charactersValue = value.replace(/([!&#,.'"()_-])/g, "");

	return charactersValue;
};

export const specialCharactersForVendor = value => {
	if (!value) {
		return value;
	}

	const regex = /^[0-9a-z&\-_.,!#'"()]*$/i;

	return regex.test(value)
		? null
		: `Only latin letters, digits and !, &, #, _, ., ', ", () are allowed`;
};

export const regExpOneSpace = value => {
	if (!value) {
		return value;
	}

	const regex = /^(?!.*\s\s)\S(.*\S)?$/;
	return regex.test(value) ? null : `Only one space can be added`;
};

export const onlyTwoDigits = value => {
	if (!value) {
		return value;
	}
	const onlyNums = value.replace(/[^\d]/g, "");
	return `${onlyNums.slice(0, 2)}`;
};

export const onlyTwoUpperCaseLetters = value => {
	if (!value) {
		return value;
	}
	const word = value.replace(/[^a-zA-Z]/g, "").toUpperCase();
	return `${word.slice(0, 2)}`;
};

// The Luhn Algorithm (mod 10).
export const validCreditCard = value => {
	if (!value) {
		return undefined;
	}

	let nCheck = 0,
		bEven = false;
	value = value.replace(/\D/g, "");

	for (var n = value.length - 1; n >= 0; n--) {
		var cDigit = value.charAt(n),
			nDigit = parseInt(cDigit, 10);

		if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

		nCheck += nDigit;
		bEven = !bEven;
	}

	return nCheck && nCheck % 10 === 0
		? undefined
		: "Credit card number is invalid";
};

export const positive = (value, previousValue) =>
	value >= 0 ? value : previousValue;

export const normalizeTaxId = value => {
	if (!value) {
		return value;
	}

	const onlyNums = value.replace(/[^\d]/g, "");
	if (onlyNums.length <= 2) {
		return onlyNums;
	}
	return `${onlyNums.slice(0, 2)}-${onlyNums.slice(2, 9)}`;
};

export const normalizeSSN = value => {
	if (!value) {
		return value;
	}

	const onlyNums = value.replace(/[^\d]/g, "");
	if (onlyNums.length <= 3) {
		return onlyNums;
	}
	if (onlyNums.length <= 5) {
		return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 5)}`;
	}
	return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 5)}-${onlyNums.slice(
		5,
		9,
	)}`;
};

export const normalizeCreditCardExpDate = value => {
	if (!value) {
		return value;
	}

	const onlyNums = value.replace(/[^\d]/g, "");
	if (onlyNums.length <= 2) {
		return onlyNums;
	}

	return `${onlyNums.slice(0, 2)}/${onlyNums.slice(2, 4)}`;
};

export const onlyFloat = (value, previousValue) => {
	if (!value) {
		return value;
	}

	// eslint-disable-next-line no-useless-escape
	const onlyNums = value.replace(/[^\d\.]/g, "");
	return /^\d{0,20}(\.\d{0,2})?$/.test(onlyNums) ? onlyNums : previousValue;
};

export const reverse = str => str.split("").reverse().join("");

export const normalizeFloatWithGrouping = value => {
	if (isNaN(value)) {
		return value;
	}

	if (!value) {
		value = "0";
	}

	let [integer, fraction] = value.toString().split(".");

	//Reverse value to prevent grouping like XXX,XX instiad of XX,XXX (wrong coma position)
	let reversedInt = reverse(integer);
	reversedInt = reversedInt.match(/-?\d{1,3}/g).join(",");
	let groupedInteger = reverse(reversedInt);

	const isFloat = !!fraction;
	if (!isFloat) {
		fraction = "00";
	}

	if (fraction.length < 2) {
		fraction = fraction + "0";
	}

	if (fraction.length > 2) {
		fraction = (Math.round(fraction * 10) / 10).toString();
	}

	return `${groupedInteger}.${fraction}`;
};

export const normalizeFloat = value => {
	if (value === null || value === undefined || value === "" || isNaN(value)) {
		return value;
	}

	let [integer, fraction] = value.toString().split(".");

	const isFloat = !!fraction;
	if (!isFloat) {
		fraction = "00";
	}

	if (fraction.length < 2) {
		fraction = fraction + "0";
	}

	if (fraction.length > 2) {
		fraction = (Math.round(fraction * 10) / 10).toString();
	}

	const result = `${integer}.${fraction}`;

	return result;
};

export const maxLength2 = maxLength(2);
export const maxLength3 = maxLength(3);
export const maxLength4 = maxLength(4);
export const maxLength9 = maxLength(9);
export const maxLength10 = maxLength(10);
export const maxLength12 = maxLength(12);
export const maxLength14 = maxLength(14);
export const maxLength13 = maxLength(13);
export const maxLength15 = maxLength(15);
export const maxLength16 = maxLength(16);
export const maxLength20 = maxLength(20);
export const maxLength30 = maxLength(30);
export const maxLength100 = maxLength(100);
export const minLength2 = minLength(2);
export const minLength3 = minLength(3);
export const minLength7 = minLength(7);
export const minLength8 = minLength(8);
export const minLength9 = minLength(9);
export const minLength10 = minLength(10);
export const minLength12 = minLength(12);

export const minLength5 = minLength(5);
export const maxLength50 = maxLength(50);

export const maxValue31 = maxValue(31);
export const maxValue16 = maxValue(16);
export const maxValue10 = maxValue(10);
export const maxValue13 = maxValue(13);
export const maxValue9 = maxValue(9);
export const maxValue3 = maxValue(3);
export const maxValue5 = maxValue(5);
export const maxValue20 = maxValue(20);
export const maxValue100 = maxValue(100);
export const maxValue30 = maxValue(30);
export const maxValueEx100 = maxValueEx(100);
export const maxDays5 = maxValueEx(5, "days");
export const maxValue12 = maxValue(12);
export const maxValue2019 = maxValue(2019);
export const maxValue2400 = maxValue(2400);
export const minValue1900 = minValue(1900);
export const minValue2 = minValue(2);
export const minValue9 = minValue(9);
export const minValue12 = minValue(12);
export const minValue3 = minValue(3);

export const maxValueForANData100 = maxValueForANData(100);
export const maxValueForANData30 = maxValueForANData(30);
export const maxValueForANData20 = maxValueForANData(20);

export const maxValueForNumberData16 = maxValueForNumberData(16);
export const maxValueForNumberData10 = maxValueForNumberData(10);
export const maxValueForNumberData13 = maxValueForNumberData(13);
export const maxValueForNumberData9 = maxValueForNumberData(9);
export const maxValueForNumberData3 = maxValueForNumberData(3);
export const maxValueForNumberData2400 = maxValueForNumberData(2400);

export const minValueForNumberData2 = minValueForNumberData(2);
export const minValueForNumberData3 = minValueForNumberData(3);
export const minValueForNumberData9 = minValueForNumberData(9);
export const minValueForNumberData12 = minValueForNumberData(12);

export const minValueForANData2 = minValueForANData(2);

export const maxLengthPhone14 = maxLengthPhone(14);
export const minLengthPhone14 = minLengthPhone(14);
export const minLengthPhone8 = minLengthPhone(8);

//Business Info
export const validateHowDoYouAcceptCards = (value, allValues) => {
	let swiped = parseFloat(allValues.swiped) || 0;
	let commerse = parseFloat(allValues.eCommerce) || 0;
	let keyed = parseFloat(allValues.keyed) || 0;

	let isAddUp100 = swiped + commerse + keyed >= 100;
	if (!isAddUp100 && !value) {
		return "Field is required";
	}
};

export const validateWhenRefundPolicyIsOther = (value, allValues) => {
	if (allValues.refundPolicy !== "Other" || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenMinDeliveryEnabled = (value, allValues) => {
	if (!allValues.minDelivery || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenHasAProcessorEverTerminatedYourMerchantAccount = (
	value,
	allValues,
) => {
	if (
		allValues.hasAProcessorEverTerminatedYourMerchantAccount === "false" ||
		value
	) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenHasMerchbennPrevIdentifiedByVisaMCRiskProgram = (
	value,
	allValues,
) => {
	if (
		allValues.hasMerchbennPrevIdentifiedByVisaMCRiskProgram === "false" ||
		value
	) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenAvgDeliveryEnabled = (value, allValues) => {
	if (!allValues.avgDelivery || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenMaxDeliveryEnabled = (value, allValues) => {
	if (!allValues.maxDelivery || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenUseAThirdPartyForFulfillment = (value, allValues) => {
	if (allValues.doYouUseAThirdPartyForFulfillment === "false" || value) {
		return undefined;
	}
	return "Field is required";
};
export const validateWhenMerchPrincipalIsOwnerBankruptcy = (
	value,
	allValues,
) => {
	if (allValues.merchPrincipalOwnerBankruptcy === "false" || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenCreditDebitCardTransactionsSettledTypeIsOther = (
	value,
	allValues,
) => {
	if (
		allValues.creditAndDebitCardTransactionsAreSettled !== "Other" ||
		value
	) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenAcceptedCardsPreviosly = (value, allValues) => {
	if (allValues.haveYouAcceptedCardsPreviously === "false" || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenPaymentTypeIsACH = (value, allValues) => {
	if (allValues.paymentType !== "ach" || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenPaymentTypeIsCreditCard = (value, allValues) => {
	if (allValues.paymentType !== "CreditCard" || value) {
		return undefined;
	}
	return "Field is required";
};

export const requiredWhenTerminalTypeIsNotFileBuildOnly = (
	value,
	allValues,
) => {
	if (allValues.terminalType === "ReprogramFileBuildOnly" || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenPointTypeIsFirshData = (value, allValues) => {
	if (allValues.pointType !== "FirstData" || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenPointTypeIsTSYS = (value, allValues) => {
	if (allValues.pointType !== "TSYS" || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenCheckServicesEnabled = (value, allValues) => {
	if (!allValues.checkServices || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenGiftLoyaltyEnabled = (value, allValues) => {
	if (!allValues.giftLoyalty || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenOnlinePortalEnabled = (value, allValues) => {
	if (!allValues.onlinePortal || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenMobileAppEnabled = (value, allValues) => {
	if (!allValues.mobileApp || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenACHEnabled = (value, allValues) => {
	if (!allValues.ach || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateSeasonalAdditional = (value, allValues) => {
	if (!allValues.seasonalChecked || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenTypeOfBusinessIsOther = (value, allValues) => {
	if (allValues.typeOfBusiness !== "Other" || value) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenTypeOfLocationIsOther = (value, allValues) => {
	if (
		(allValues.locationSection &&
			allValues.locationSection.typeOfLocation !== "Other") ||
		value
	) {
		return undefined;
	}
	return "Field is required";
};

export const validateWhenAmexESA = (value, allValues) => {
	if (allValues.isAmexESA !== "true" || value) {
		return undefined;
	}
	return "Field is required";
};
export const validateWhenOptBlue = (value, allValues) => {
	if (allValues.isAmexESA !== "false" || value) {
		return undefined;
	}
	return "Field is required";
};

export const dateValidation = (value, allValues) => {
	try {
		if (!value) {
			return undefined;
		}

		if (value.length !== 10) {
			return "Invalid date";
		}
		let date = moment(value, "MM/DD/YYYY");
		if (!date.isValid()) {
			return "Invalid date";
		}
	} catch (error) {
		return "Invalid date";
	}
	return undefined;
};

export const maxDateNow = value => {
	if (!value) {
		return undefined;
	}

	const enteredDate = moment(value, "MM/DD/YYYY");
	const isFuture = enteredDate.isAfter(moment());
	if (isFuture) {
		return "Date must be in the past";
	}
};

export const validateForEndDate = (value, allValues) => {
	if (!value) {
		return undefined;
	}

	let checkEndDate = moment(value).isSameOrBefore(allValues.startDate);
	if (checkEndDate) {
		return "The end date must not be less than the start date";
	}

	if (allValues.startDate.length < 1) {
		return "Cannot specify an end date without a start date";
	}
};

export const minDateYearAgo = value => {
	if (!value) {
		return undefined;
	}

	const enteredDate = moment(value, "MM/DD/YYYY");
	const isFuture = enteredDate.isBefore(moment().subtract(1, "years"));
	if (isFuture) {
		return "Date should be not older than 1 year from now";
	}
};

export const minYear = year => value => {
	const FORMAT = "MM/DD/YYYY";
	const mDate = moment(value, FORMAT);
	if (value && mDate.year() < year) {
		return `Date should be greater than 01/01/${year}`;
	}
	return undefined;
};

export const dateOfBirth1900 = (value, allValues) => {
	if (value && moment(value, "MM/DD/YYYY").year() < 1900) {
		return "Date should be greater than 01/01/1900";
	}
	return undefined;
};

export const dateOfBirth1970 = (value, allValues) => {
	if (value && moment(value, "MM/DD/YYYY").year() < 1970) {
		return "Date should be greater than 01/01/1970";
	}
	return undefined;
};

export const dateOfminYear1990 = (value, allValues) => {
	if (value && moment(value, "MM/DD/YYYY").year() < 1990) {
		return "Date should be greater than 01/01/1990";
	}
	return undefined;
};

export const dateOfBirthMoreThan18 = (value, allValues) => {
	let enteredDate = moment(value, "MM/DD/YYYY");
	if (moment().add(-18, "years").isBefore(enteredDate)) {
		return "Age must be greater than 18 years";
	}
	return undefined;
};

export const validExpDate = (value, allValues) => {
	let enteredDate = moment(value, "MM/YY");
	if (value && (value.length !== 5 || !enteredDate.isValid())) {
		return "Invalid date";
	}

	if (value && moment() && !moment().isBefore(enteredDate)) {
		return "Date must be greaner than now";
	}

	let dateNoMoreThan10years = moment().add(10, "y").format("YY");
	let enteredYear = moment(enteredDate).format("YY");

	if (enteredYear > dateNoMoreThan10years) {
		return "Date must be not farther than 10 years";
	}

	return undefined;
};

export const requiredIfSignerExists = (value, allValues) => {
	let hasSigner =
		allValues &&
		allValues.ownerPrincipalSection &&
		allValues.ownerPrincipalSection.signer &&
		allValues.ownerPrincipalSection.signer.id >= 0;
	if (hasSigner || value) {
		return undefined;
	} else {
		return "Field is required";
	}
};

export const validateWhenDoYouAcceptWEXVoyager = (value, allValues) => {
	if (allValues.doYouAcceptWEXVoyager !== "true" || value) {
		return undefined;
	}
	return "Field is required";
};

export const addressValidation = [
	required,
	matchesAddressRegex,
	minLength2,
	maxLength50,
];

export const notRequiredAddress = [
	matchesAddressRegex,
	minLength2,
	maxLength50,
];

export const conditionalVaildation = (
	condition,
	validators,
	value,
	allValues,
) => {
	const conditionalValidators = condition ? validators : [];

	for (let validator of conditionalValidators) {
		const error = validator(value, allValues);
		if (error) return error;
	}

	return undefined;
};

export const matchesPasswordRegex = allowed(
	/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).*$/,
	`Must contain at least 1 lowercase and 1 uppercase letters, 1 digit and 1 special character`,
);

export const substrByName = (compName, msg) => (value, allValues) => {
	if (!value || !allValues[compName]) return null;

	const valueLowercase = value.toLocaleLowerCase();
	const compLowercase = allValues[compName].toLocaleLowerCase();

	return !valueLowercase.includes(compLowercase)
		? null
		: msg || `Contains ${compName}`;
};

export const confirmByName = (name, message) => (value, allValues) => {
	return value === allValues[name] ? null : message;
};

export const passwordConfirmation = confirmByName(
	`password`,
	`Passwords don't match`,
);

export const noUsernameSubstr = substrByName(
	`username`,
	`Shouldn't contain username`,
);

export const noUserNameSubstr = substrByName(
	`userName`,
	`Shouldn't contain username`,
);

export const applyValidatorsIf =
	predicate =>
	(validators, elseValidators) =>
	(value, allValues, props, fieldName) =>
		predicate(value, allValues, props, fieldName)
			? validators
					.map(validator => validator(value, allValues))
					.find(error => !!error)
			: elseValidators &&
			  elseValidators
					.map(validator => validator(value, allValues))
					.find(error => !!error);

export const normalizeAll =
	normalizers => (value, previousValue, allValues, previousAllValues) => {
		let i = 0;
		let normalizersLength = normalizers.length;
		let currentValue = value;
		while (i < normalizersLength) {
			let currentNormalizer = normalizers[i];
			if (typeof currentNormalizer == "function") {
				currentValue = currentNormalizer(
					currentValue,
					previousValue,
					allValues,
					previousAllValues,
				);
			}
			i++;
		}

		return currentValue;
	};

export const briefDescriptionNormalizer = value => {
	if (!value) {
		return value;
	}

	return value.replace(/[%;<>=+~^]+/g, "");
};

export const validateAddressComponents = (
	addressComponents,
	ignoreStreetNumber = false,
) => {
	const requiredFields = [
		GoogleAddressComponentsFields.Street,
		GoogleAddressComponentsFields.City,
		GoogleAddressComponentsFields.Region,
		GoogleAddressComponentsFields.Country,
		GoogleAddressComponentsFields.PostalCode,
	];
	// We don't have street number field on BE side, so we can't validate this field on edit pages
	if (!ignoreStreetNumber) {
		requiredFields.unshift(GoogleAddressComponentsFields.StreetNumber);
	}

	const missingFields = [];
	const errMessage = "The address is not completed.";

	requiredFields.forEach(field => {
		if (!addressComponents?.[field.name]) {
			missingFields.push(field.displayName);
		}
	});

	if (missingFields.length > 1) {
		return `${errMessage} Missing fields: ${missingFields.join(", ")}.`;
	} else if (missingFields.length === 1) {
		return `${errMessage} Missing field: ${missingFields.join(", ")}.`;
	}
	return null;
};

export const validateLatLng =
	sectionName =>
	(_value, fields = {}) => {
		if (isEmptyObject(fields) || !fields) return undefined;

		const address = getObjectByPath(fields, sectionName);

		const lat = address?.lat;
		const lng = address?.lng;

		if (lat === undefined || lng === undefined) {
			return ValidationMessages.AddressNotVerified;
		}

		if (
			!address ||
			checkAddressFieldsEmpty(address) ||
			checkIsLatOrLngManual({
				lat,
				lng,
			})
		)
			return undefined;

		if (lat && lng) {
			return validateAddressComponents(address, true) || undefined;
		}

		return ValidationMessages.AddressNotVerified;
	};
